import Image from "next/image";
import ring from "public/ring.png";

type PersonalityCard = {
  name: string;
  year: string;
  img: string;
};

export default function PersonalityCard(props: PersonalityCard) {
  const { name, year, img } = props;
  return (
    <div className="flex h-[460px] w-full items-center justify-center rounded-[60px] bg-foreground px-4 py-12 sm:w-[400px] lg:w-full xl:h-[480px] xl:py-16">
      <div className="flex flex-col items-center gap-12 pt-4 sm:gap-16 md:gap-20">
        <div className="relative h-[120px] w-[120px] rounded-full xl:h-[180px] xl:w-[180px]">
          <Image
            src={img}
            alt={name}
            fill
            objectFit="cover"
            className="rounded-full"
          />
          <div className="absolute inset-0 flex scale-[2.7] transform items-center justify-center">
            <Image
              draggable={false}
              src={ring}
              alt="ring"
              fill
              objectFit="contain"
            />
          </div>
        </div>

        <div className="flex flex-col gap-2 text-center sm:gap-4">
          <h4 className="text-2xl text-secondary xl:text-[34px] ltr:font-playfair">
            {name}
          </h4>
          <p className="text-lg lg:text-xl">{year}</p>
        </div>
      </div>
    </div>
  );
}
